export default "__VITE_ASSET__oOgFBTwp__"